/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * * `MEDICAL_DIRECTOR` - Medical Director
 * * `ASSISTANT_MEDICAL_DIRECTOR` - Assistant Medical Director
 * * `CLINICAL_DIRECTOR` - Clinical Director
 * * `SCHEDULER` - Scheduler
 */
export enum RoleEnum {
    MEDICAL_DIRECTOR = 'MEDICAL_DIRECTOR',
    ASSISTANT_MEDICAL_DIRECTOR = 'ASSISTANT_MEDICAL_DIRECTOR',
    CLINICAL_DIRECTOR = 'CLINICAL_DIRECTOR',
    SCHEDULER = 'SCHEDULER',
}
